import React from 'react';

import { Col, Row } from 'reactstrap';
import styled from 'styled-components';

import MegaMenuItemBodyContentLinks from 'components/Layout/Header/components/MegaMenuItem/components/MegaMenuItemBody/components/MegaMenuItemBodyContentLinks';
import MegaMenuItemBodyLinkList from 'components/Layout/Header/components/MegaMenuItem/components/MegaMenuItemBody/components/MegaMenuItemBodyLinkList';

import { MenuColumnSubMenuItemI } from 'interfaces/content-stack/contentStack.types';

interface MegaMenuBodyProps {
  data?: {
    linkText?: string;
    snippet?: string;
    submenu: MenuColumnSubMenuItemI[];
  }[];
}

const MegaMenuBodyColumnContainer = styled(Col)`
  max-width: 25rem;
`;

const MegaMenuItemBody: React.FC<MegaMenuBodyProps> = ({ data }) => {
  if (!data) {
    return null;
  }

  const colSize = 12 / data.length;
  return (
    <Row>
      {data.map((column, index) => (
        <MegaMenuBodyColumnContainer md={colSize} key={index}>
          {column.submenu.map((menuItem, menuItemIndex) => (
            <React.Fragment key={menuItemIndex}>
              {menuItem.tertiaryMenuItems?.length ? (
                <MegaMenuItemBodyLinkList linkList={menuItem} />
              ) : (
                <MegaMenuItemBodyContentLinks contentLinks={menuItem} />
              )}
            </React.Fragment>
          ))}
        </MegaMenuBodyColumnContainer>
      ))}
    </Row>
  );
};

export default MegaMenuItemBody;
